import { Button, Dropdown, Input, Menu, Modal, notification, Table, TableColumnsType } from 'antd';
import React, { Fragment, PureComponent, ReactNode } from 'react';
import { DeleteOutlined, SearchOutlined } from '@ant-design/icons';

import {
    GAdvice,
    GenieItem,
    GLabTest,
    GMedication,
    GSymptomsDiagnosis,
    SectionNameConfig,
} from '../../store/db';
import { DB_TABLES } from '../../store/dbTables';
import {
    getDefaultTemplateV2,
    getG,
    getItemFromMisc,
    getMySingleDoctorId,
    getTemplates,
    MISC_KEYS,
} from '../../store/idbHandler';
import GenieConfiguration, {
    ADVICES,
    DIAGNOSIS,
    EXAMINATION_FINDINGS,
    ItemId,
    LAB_INVESTIGATIONS,
    LAB_VITALS,
    MEDICINES,
    notMedicineObj,
    SYMPTOMS,
} from './GenieConfiguration';
import AppLoader from '../../components/common/AppLoader';
import { ColumnType } from 'antd/lib/table';
import {
    FilterConfirmProps,
    FilterValue,
    SorterResult,
    TableCurrentDataSource,
    TablePaginationConfig,
} from 'antd/lib/table/interface';
import GenieMedTable from '../GenieMedTable';
import pushGenie, { GeniePadElementsSettingItem, GenieSettings } from '../../api/pushGenie';
import ElementsConfigureTable from '../../components/prescriptionPad/rightPanel/workspace/padV2/ElementsConfigureTable';
import CodeStatusFilters, { filtersObj } from './CodeStatus';
import { MedicationsEntity, MedicineCategory } from '../../store/types/prescription';
import { GenieVersion, LOCAL_ID_PREFIX } from '../../constants';
import fetchDrugSearch, { CodedMedications } from '../../api/fetchDrugSearch';
import AntAutoCompleteV2 from '../../components/prescriptionPad/rightPanel/workspace/padV2/AntAutoComplete';
import { onFormSearch } from '../../components/prescriptionPad/rightPanel/workspace/padV2/onFormSearch';
import { extractProperties } from '../../components/common/ExtractProperties';
import { captureError, captureErrorString } from '../captureError';
import { track } from '../../tracking';
import { onGenericCompositionSearch } from '../../components/prescriptionPad/rightPanel/workspace/padV2/onGenericCompositionSearch';
import BlockHistoryGenie from '../prescriptionPad/BlockHistoryGenie';
import SearchAndReplaceMedicine from './SearchAndReplaceMedicine';
import { apiDrugToMedicationEntity } from '../../components/prescriptionPad/rightPanel/workspace/PrescribeAutoSuggestV2';
import { onManufacturerSearch } from '../../components/prescriptionPad/rightPanel/workspace/padV2/onManufacturerSearch';
import {
    FROM_GENIE_DASHBOARD,
    GD_SEARCH_REPLACE,
    GD_SUGGESTED,
} from '../../components/prescriptionPad/trackSource';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { GO_TO_MY_GENIE, GO_TO_MY_RX_TEMPLATE } from '../../routes/paths';
import debounce from 'lodash/debounce';
import { ThunkDispatch } from 'redux-thunk';
import { GlobalState } from '../../store/reducers';
import { Actions } from '../../store/actions';
import { fetchSnackingQuestions, upsertSectionNameConfig } from '../../store/actions/session';
import { OptionItem } from './OptionItem';
import EmptyView from './EmptyView';
import AddMedicines from './AddMedicines';
import { fetchMyGenie } from '../../store/actions/login';
import { setIsPageBlocked } from '../../App';
import { IssuesWithSuggestion } from './IssuesWithSuggestion';
import { getSectionNameConfig } from '../../store/selectors/session';
import { getRxClinicId } from '../../store/selectors/prescriptionPad';
import { his } from '../history';
import { AntTooltip } from '../../components/common/AntTooltip';
import GenieMemorySidebar from './GenieMemorySidebar';

export const notADrugObj: { [k: string]: string } = {
    device: 'a Device',
    advice: 'an Advice',
};

interface Props extends RouteComponentProps<{ filter: FilterType }> {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    itemId: ItemId;
    name: string;
    autoCopyConfig?: GeniePadElementsSettingItem[];
    sectionNameConfig?: SectionNameConfig;
    rxClinicId?: string;
}

interface ExtraGenieKeys {
    suggestions?: CodedMedications[];
    currentItemStatus?: 'coded' | 'uncoded' | 'nad';
}

export type Item = GSymptomsDiagnosis | GMedication | GLabTest | GAdvice;

export type GUIItem = Item & ExtraGenieKeys;

type DataType = {
    name: string;
    text: string;
};
type DataIndex = keyof DataType;

type State = {
    items?: Item[];
    isLoading?: boolean;
    element: GenieItem | undefined;
    filterState: FilterType;
    isSaveChangesLoading: boolean;
    isStateChanged: boolean;
    tableKey: number;
    searchAndReplaceMedicine?: Item;
    isAddMedicinesDialogVisible?: boolean;
    sectionNameConfig?: SectionNameConfig;
    editSectionId?: string;
};

export type FilterType = 'all' | 'uncoded' | 'coded' | 'nad';
export type FilterData = { [k in FilterType]: { count: number; amount?: number } };

class ListGenieItems extends PureComponent<Props, State> {
    tableRef: React.RefObject<HTMLInputElement> = React.createRef();
    counts: FilterData | undefined = undefined;
    pageSize = 30;
    showDashboardFilters = [MEDICINES, LAB_INVESTIGATIONS];
    state: State = {
        isLoading: true,
        element: undefined,
        filterState: this.props.match.params.filter,
        isSaveChangesLoading: false,
        isStateChanged: false,
        tableKey: 0,
        editSectionId: undefined,
    };

    config = GenieConfiguration.configs.find((c) => c.id === this.props.itemId);

    handleSearch = (confirm: (param?: FilterConfirmProps) => void): void => {
        confirm({ closeDropdown: false });
    };

    handleReset = (clearFilters: () => void, confirm: () => void): void => {
        confirm();
        clearFilters();
    };

    getColumnSearchProps = (dataIndex: DataIndex): ColumnType<DataType> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
            return (
                <div className="p-8" onKeyDown={(e) => e.stopPropagation()}>
                    <Input
                        autoFocus={true}
                        placeholder={`Search ${dataIndex}`}
                        value={selectedKeys[0]}
                        onChange={(e) => {
                            setSelectedKeys(e.target.value ? [e.target.value] : []);
                            this.handleSearch(confirm);
                        }}
                        className="mb-8"
                    />
                    <div className="flex items-center justify-between">
                        <Button
                            onClick={() => {
                                setSelectedKeys([]);
                                clearFilters && confirm && this.handleReset(clearFilters, confirm);
                            }}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Reset
                        </Button>
                        <Button
                            type="link"
                            size="small"
                            onClick={() => {
                                confirm();
                            }}
                        >
                            close
                        </Button>
                    </div>
                </div>
            );
        },
        filterIcon: (filtered: boolean) => (
            <SearchOutlined
                style={{ color: filtered ? '#1890ff' : undefined }}
                onPointerLeaveCapture={undefined}
            />
        ),
        onFilter: (value, record) => {
            return record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase());
        },
    });

    getColumns = (itemId: string, filterType: FilterType): ColumnType<Item>[] => {
        return [
            {
                title: '#',
                dataIndex: 'index',
                key: 'index',
                width: 40,
                render: (text: string, record: Item, index: number): ReactNode => (
                    <div className="flex items-center justify-center">
                        <span>{index + 1}</span>
                    </div>
                ),
            },
            {
                title: 'Name',
                key: 'name',
                width: this.config?.nameColumnWidth,
                ...this.getColumnSearchProps(itemId === ADVICES ? 'text' : 'name'),
                render: (text: string, record: Item): ReactNode => (
                    <div className="flex items-center justify-start">
                        {this.config?.getName(record)}
                    </div>
                ),
                sorter: this.config?.sorter,
            },
            itemId === MEDICINES &&
                filterType === 'nad' && {
                    title: 'Category',
                    key: 'category',
                    width: 120,
                    render: (text: string, record: Item): ReactNode => (
                        <div className="flex items-center justify-start">
                            {notMedicineObj[(record as GMedication).med_cat || '']}
                        </div>
                    ),
                    filters: [
                        {
                            text: 'Device',
                            value: 'device',
                        },
                        {
                            text: 'Advice',
                            value: 'advice',
                        },
                        {
                            text: 'Not a Drug',
                            value: 'nad',
                        },
                    ],
                    onFilter: (value: string | number | boolean, record: Item): boolean =>
                        (record as GMedication).med_cat?.indexOf(value as string) === 0,
                },
            this.config?.renderRemark && {
                title: 'Remark',
                key: 'remark',
                width: '40%',
                render: (text: string, record: GLabTest): ReactNode =>
                    !record.id.startsWith(LOCAL_ID_PREFIX) ? (
                        <p>{record.remark || '—'}</p>
                    ) : (
                        <Input
                            placeholder={'Add remark here'}
                            defaultValue={record.remark}
                            onBlur={(e) => this.onRemarkChange(record.id, e.target.value)}
                            allowClear
                            key={record.id + record.remark}
                        />
                    ),
                filters: [
                    {
                        text: 'Remark Missing',
                        value: 'missing',
                    },
                    {
                        text: 'Remark Filled',
                        value: 'filled',
                    },
                ],
                onFilter: (value: string, record: GLabTest) => {
                    const isRemarkMissing = !record.remark;
                    return value === 'missing'
                        ? isRemarkMissing
                        : value === 'filled'
                        ? !isRemarkMissing
                        : '';
                },
                filterMultiple: false,
            },
            this.config?.renderForm && {
                title: 'Form',
                key: 'form',
                width: '12%',
                render: (text: string, record: GMedication): ReactNode =>
                    !record.id.startsWith(LOCAL_ID_PREFIX) ? (
                        <p>{record.dosage_form || record.form || '—'}</p>
                    ) : (
                        <AntAutoCompleteV2
                            placement={'bottomLeft'}
                            onSearch={onFormSearch}
                            selectedValue={record.dosage_form || record.form}
                            debounceDelay={200}
                            getLabelToCompare={(o) => o}
                            placeholder={'Form'}
                            onSelect={(option) => this.onFormChange(record.id, option)}
                            customDropdownWidth={150}
                            key={record.id + (record.form || record.dosage_form)}
                            containerSelectorToAttachDropdown={'.hover-parent-element'}
                        />
                    ),
                filters: [
                    {
                        text: 'Form Missing',
                        value: 'missing',
                    },
                    {
                        text: 'Form Filled',
                        value: 'filled',
                    },
                ],
                onFilter: (value: string, record: GMedication) => {
                    const isFormMissing = !record.dosage_form && !record.form;
                    return value === 'missing'
                        ? isFormMissing
                        : value === 'filled'
                        ? !isFormMissing
                        : '';
                },
                filterMultiple: false,
            },
            this.config?.renderGeneric && {
                title: 'Generic',
                key: 'generic',
                width: '20%',
                render: (text: string, record: GMedication): ReactNode =>
                    !record.id.startsWith(LOCAL_ID_PREFIX) ? (
                        <p>{record.generic_name || '—'}</p>
                    ) : (
                        <AntAutoCompleteV2
                            placement={'bottomLeft'}
                            onSearch={onGenericCompositionSearch}
                            selectedValue={
                                record.generic_name
                                    ? {
                                          name: record.generic_name || '',
                                          id: record.generic_id || '',
                                      }
                                    : undefined
                            }
                            debounceDelay={200}
                            getLabelToCompare={(o) => o.name}
                            placeholder={'Generic'}
                            onSelect={(option) => this.onGenericNameChange(record.id, option)}
                            customDropdownWidth={300}
                            key={record.id + record.generic_name}
                            containerSelectorToAttachDropdown={'.hover-parent-element'}
                        />
                    ),
                filters: [
                    {
                        text: 'Generic Missing',
                        value: 'missing',
                    },
                    {
                        text: 'Generic Filled',
                        value: 'filled',
                    },
                ],
                onFilter: (value: string, record: GMedication) => {
                    const isGenericMissing = !record.generic_name;
                    return value === 'missing'
                        ? isGenericMissing
                        : value === 'filled'
                        ? !isGenericMissing
                        : '';
                },
                filterMultiple: false,
            },
            this.config?.renderManufacturer && {
                title: 'Mfr.',
                key: 'manufacturer',
                width: '12%',
                render: (text: string, record: GMedication): ReactNode =>
                    !record.id.startsWith(LOCAL_ID_PREFIX) ? (
                        <p>{record.manufacturer_name || '—'}</p>
                    ) : (
                        <AntAutoCompleteV2
                            placement={'bottomLeft'}
                            onSearch={onManufacturerSearch}
                            selectedValue={
                                record.manufacturer_name
                                    ? {
                                          name: record.manufacturer_name || '',
                                          id: record.manufacturer_id || '',
                                      }
                                    : undefined
                            }
                            debounceDelay={200}
                            getLabelToCompare={(o) => o.name}
                            placeholder={'Manufacturer'}
                            onSelect={(option) => this.onManufacturerNameChange(record.id, option)}
                            customDropdownWidth={200}
                            key={record.id}
                            containerSelectorToAttachDropdown={'.hover-parent-element'}
                        />
                    ),
                filters: [
                    {
                        text: 'Manufacturer Missing',
                        value: 'missing',
                    },
                    {
                        text: 'Manufacturer Filled',
                        value: 'filled',
                    },
                ],
                onFilter: (value: string, record: GMedication) => {
                    const isManufacturerMissing = !record.manufacturer_name;
                    return value === 'missing'
                        ? isManufacturerMissing
                        : value === 'filled'
                        ? !isManufacturerMissing
                        : '';
                },
                filterMultiple: false,
            },
            this.config?.renderProperties && {
                title: 'Properties',
                key: 'properties',
                hidden: true,
                width: filterType === 'nad' ? '22%' : '30%',
                render: (text: string, record: GMedication): ReactNode => {
                    const element = record;
                    const flatArray = [
                        {
                            ...element,
                            tapering_dose: undefined,
                            tapIndex: -1,
                        },
                    ];
                    const t = element.tapering_dose?.map((t, tapIndex) => ({
                        name: element.name,
                        id: element.id,
                        dosage_form: element.dosage_form,
                        form: element.form,
                        product_type: element.product_type,
                        generic_name: element.generic_name,
                        df_id: element.df_id,

                        tapering_dose: undefined,
                        soa: element.soa,
                        ...t,
                        tapIndex: tapIndex,
                    }));
                    t && flatArray.push(...t);

                    return (
                        <div className="break-words space-y-8">
                            {flatArray.map((el) => {
                                const properties = extractProperties.getMedicationsProperties(el);
                                return <div>{properties || '—'}</div>;
                            })}
                        </div>
                    );
                },
            },

            !this.config?.hideIsCodedColumn && {
                title: 'Coded',
                dataIndex: 'meta.isLocal',
                key: 'meta.isLocal',
                width: '25%',
                render: (text: string, record: Item): ReactNode => (
                    <div className="flex items-center justify-center">
                        <span>{!record?.meta?.isLocal ? 'Yes' : 'No'}</span>
                    </div>
                ),
                filters: [
                    {
                        text: 'Yes',
                        value: 'yes',
                    },
                    {
                        text: 'No',
                        value: 'No',
                    },
                ],
                onFilter: (value: string | number | boolean, record: Item): boolean => {
                    if (record?.meta?.isLocal === undefined) {
                        return true;
                    } else if (value === 'yes') {
                        return !record.meta.isLocal;
                    } else {
                        return record.meta.isLocal === 1;
                    }
                },
            },
            {
                title: itemId === MEDICINES ? 'count' : 'Usage count',
                dataIndex: 'meta.fCount',
                key: 'meta.fCount',
                width: this.config?.usageCountColumnWidth,
                render: (text: string, record: Item): ReactNode => (
                    <div className="flex items-center justify-center">
                        <span>{record?.meta?.fCount}</span>
                        {this.config?.hideDeleteIcon && (
                            <div className="hover-child-element absolute top-0 right-0 bottom-0">
                                <div className="h-full flex items-center space-x-12 whitespace-nowrap bg-darwin-primary-100 px-16">
                                    {record.id.startsWith(LOCAL_ID_PREFIX) && (
                                        <Fragment>
                                            <button
                                                className="flex items-center px-16 py-8 space-x-8 bg-darwin-primary-500 rounded-4"
                                                onClick={() => {
                                                    this.setState({
                                                        searchAndReplaceMedicine: record,
                                                    });
                                                }}
                                            >
                                                <svg
                                                    className="w-14 h-14 fill-white"
                                                    viewBox="0 0 13 13"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M8.61719 4.08594L8.3125 2.9375L7.16406 2.63281C7.07031 2.58594 7 2.49219 7 2.375C7 2.28125 7.07031 2.1875 7.16406 2.14062L8.3125 1.8125L8.61719 0.6875C8.66406 0.59375 8.75781 0.5 8.875 0.5C8.96875 0.5 9.0625 0.59375 9.10938 0.6875L9.4375 1.8125L10.5625 2.14062C10.6562 2.1875 10.75 2.28125 10.75 2.375C10.75 2.49219 10.6562 2.58594 10.5625 2.63281L9.4375 2.9375L9.10938 4.08594C9.0625 4.17969 8.96875 4.25 8.875 4.25C8.75781 4.25 8.66406 4.17969 8.61719 4.08594ZM5.99219 4.20312L7.07031 6.40625L9.50781 6.75781C9.95312 6.82812 10.1406 7.39062 9.8125 7.71875L8.05469 9.42969L8.47656 11.8438C8.54688 12.3125 8.07812 12.6641 7.65625 12.4531L5.47656 11.3047L3.32031 12.4531C2.89844 12.6641 2.42969 12.3125 2.5 11.8438L2.92188 9.42969L1.16406 7.71875C0.835938 7.39062 1 6.82812 1.46875 6.75781L3.90625 6.40625L4.98438 4.20312C5.19531 3.78125 5.78125 3.78125 5.99219 4.20312ZM11.0312 6.21875L10.1406 5.96094C10.0469 5.9375 10 5.84375 10 5.75C10 5.67969 10.0469 5.58594 10.1406 5.5625L11.0312 5.30469L11.2891 4.41406C11.3125 4.32031 11.4062 4.25 11.5 4.25C11.5703 4.25 11.6641 4.32031 11.6875 4.41406L11.9453 5.30469L12.8359 5.5625C12.9297 5.58594 13 5.67969 13 5.75C13 5.84375 12.9297 5.9375 12.8359 5.96094L11.9453 6.21875L11.6875 7.10938C11.6641 7.20312 11.5703 7.25 11.5 7.25C11.4062 7.25 11.3125 7.20312 11.2891 7.10938L11.0312 6.21875Z" />
                                                </svg>

                                                <span className="text-white font-700 text-13">
                                                    Replace with
                                                </span>
                                            </button>

                                            {!(record as GMedication).med_cat && (
                                                <button
                                                    className={`flex items-center px-16 py-5 space-x-8 bg-white rounded-4 border ${
                                                        (record as GMedication).is_otc
                                                            ? 'border-darwin-accent-green-900'
                                                            : 'border-darwin-primary-500'
                                                    }`}
                                                    onClick={() => this.onOTCChange(record.id)}
                                                >
                                                    <span
                                                        className={`text-16 ${
                                                            (record as GMedication).is_otc
                                                                ? 'text-darwin-accent-green-900'
                                                                : 'text-darwin-primary-500 '
                                                        }`}
                                                    >
                                                        ✓
                                                    </span>

                                                    <span
                                                        className={`${
                                                            (record as GMedication).is_otc
                                                                ? 'text-darwin-accent-green-900'
                                                                : 'text-darwin-primary-500 '
                                                        } font-700 text-13`}
                                                    >
                                                        {(record as GMedication).is_otc
                                                            ? 'Marked as OTC'
                                                            : 'Mark as OTC'}
                                                    </span>
                                                </button>
                                            )}
                                        </Fragment>
                                    )}

                                    {record.id.startsWith(LOCAL_ID_PREFIX) ? (
                                        <Dropdown
                                            overlay={
                                                <Menu>
                                                    <OptionItem
                                                        onClick={() => {
                                                            this.setElement(
                                                                JSON.parse(JSON.stringify(record)),
                                                            );
                                                        }}
                                                        label={'Edit Medicine'}
                                                        leftIcon={
                                                            <svg
                                                                className="w-14 h-14 fill-darwin-primary-500 relative top-2"
                                                                viewBox="0 0 13 13"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path d="M12.1484 2.25781L10.7422 0.851562C10.3203 0.40625 9.59375 0.40625 9.14844 0.851562L7.83594 2.16406L10.8125 5.16406L12.1484 3.85156C12.5938 3.40625 12.5938 2.67969 12.1484 2.25781ZM1.22656 8.77344C1.15625 8.82031 1.13281 8.89062 1.10938 8.96094L0.5 12.0312C0.453125 12.2891 0.640625 12.5 0.851562 12.5C0.875 12.5 0.921875 12.5 0.945312 12.5L4.01562 11.8906C4.08594 11.8672 4.15625 11.8438 4.22656 11.7734L10.2969 5.70312L7.29688 2.70312L1.22656 8.77344ZM3.57031 10.8359L1.8125 11.1875L2.16406 9.42969L2.75 8.84375V10.25H4.15625L3.57031 10.8359Z"></path>
                                                            </svg>
                                                        }
                                                    />

                                                    {(record as GMedication).med_cat && (
                                                        <OptionItem
                                                            onClick={() => {
                                                                this.onMarkAsDrug(record.id);
                                                            }}
                                                            label={'Mark as Drug'}
                                                            leftIcon={
                                                                <span className="text-16 text-darwin-accent-green-900">
                                                                    ✓
                                                                </span>
                                                            }
                                                        />
                                                    )}

                                                    <OptionItem
                                                        onClick={() => this.deleteItem(record)}
                                                        label={'Delete Medicine'}
                                                        leftIcon={
                                                            <DeleteOutlined
                                                                style={{ color: 'red' }}
                                                                size={24}
                                                                onPointerLeaveCapture={undefined}
                                                                className="relative top-2"
                                                            />
                                                        }
                                                    />
                                                </Menu>
                                            }
                                            placement="bottomLeft"
                                            arrow
                                            getPopupContainer={() =>
                                                document.getElementById(record.id) || document.body
                                            }
                                        >
                                            <button
                                                className="flex items-center justify-center w-36 h-36 bg-white rounded-4 border border-darwin-primary-500"
                                                id={record.id}
                                            >
                                                <svg
                                                    className="w-5 h-14 fill-darwin-primary-500"
                                                    viewBox="0 0 4 13"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M2 9.59375C2.82031 9.59375 3.53125 10.3047 3.53125 11.125C3.53125 11.9727 2.82031 12.6562 2 12.6562C1.15234 12.6562 0.46875 11.9727 0.46875 11.125C0.46875 10.3047 1.15234 9.59375 2 9.59375ZM2 5.21875C2.82031 5.21875 3.53125 5.92969 3.53125 6.75C3.53125 7.59766 2.82031 8.28125 2 8.28125C1.15234 8.28125 0.46875 7.59766 0.46875 6.75C0.46875 5.92969 1.15234 5.21875 2 5.21875ZM3.53125 2.375C3.53125 3.22266 2.82031 3.90625 2 3.90625C1.15234 3.90625 0.46875 3.22266 0.46875 2.375C0.46875 1.55469 1.15234 0.84375 2 0.84375C2.82031 0.84375 3.53125 1.55469 3.53125 2.375Z" />
                                                </svg>
                                            </button>
                                        </Dropdown>
                                    ) : (
                                        <Fragment>
                                            <button
                                                className="flex items-center justify-center w-36 h-36 bg-white rounded-4 border border-darwin-primary-500"
                                                onClick={() => {
                                                    this.setElement(
                                                        JSON.parse(JSON.stringify(record)),
                                                    );
                                                }}
                                            >
                                                <svg
                                                    className="w-14 h-14 fill-darwin-primary-500"
                                                    viewBox="0 0 13 13"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M12.1484 2.25781L10.7422 0.851562C10.3203 0.40625 9.59375 0.40625 9.14844 0.851562L7.83594 2.16406L10.8125 5.16406L12.1484 3.85156C12.5938 3.40625 12.5938 2.67969 12.1484 2.25781ZM1.22656 8.77344C1.15625 8.82031 1.13281 8.89062 1.10938 8.96094L0.5 12.0312C0.453125 12.2891 0.640625 12.5 0.851562 12.5C0.875 12.5 0.921875 12.5 0.945312 12.5L4.01562 11.8906C4.08594 11.8672 4.15625 11.8438 4.22656 11.7734L10.2969 5.70312L7.29688 2.70312L1.22656 8.77344ZM3.57031 10.8359L1.8125 11.1875L2.16406 9.42969L2.75 8.84375V10.25H4.15625L3.57031 10.8359Z"></path>
                                                </svg>
                                            </button>

                                            <button
                                                className="flex items-center justify-center w-36 h-36 bg-white rounded-4 border border-darwin-status-warning-500"
                                                onClick={() => this.deleteItem(record)}
                                            >
                                                <DeleteOutlined
                                                    style={{ color: '#D73A2F' }}
                                                    size={24}
                                                    onPointerLeaveCapture={undefined}
                                                />
                                            </button>
                                        </Fragment>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                ),
                sorter: (a: Item, b: Item): number =>
                    (a.meta?.fCount || 0) < (b.meta?.fCount || 0) ? -1 : 1,
            },
            !this.config?.hideDeleteIcon && {
                title: 'Action',
                dataIndex: 'delete',
                key: 'delete',
                width: 75,
                render: (text: string, record: Item): ReactNode => (
                    <div className="flex items-center justify-center">
                        <DeleteOutlined
                            style={{ color: 'red' }}
                            size={24}
                            onClick={() => this.deleteItem(record)}
                            onPointerLeaveCapture={undefined}
                        />
                    </div>
                ),
            },
        ].filter(Boolean) as ColumnType<Item>[];
    };

    deleteItem = async (item: Item): Promise<void> => {
        const { items } = this.state;
        const { itemId } = this.props;
        const { showDashboardFilters } = this;
        if (items) {
            const newItems = this.config?.filter
                ? this.config.filter(items, item)
                : items.filter((i) => i.id !== item.id);
            this.setState({ items: newItems, isStateChanged: true });

            if (showDashboardFilters.includes(itemId)) {
                const filterData: FilterData = {} as FilterData;
                (Object.keys(filtersObj) as FilterType[]).forEach((k) => {
                    const t = filtersObj[k].getData(newItems);
                    filterData[k] = {
                        count: t.length,
                    };
                });
                this.counts = filterData;
            }
        }
    };

    genieMap: { [k: string]: DB_TABLES } = {
        [SYMPTOMS]: DB_TABLES.symptoms,
        [DIAGNOSIS]: DB_TABLES.diagnosis,
        [MEDICINES]: DB_TABLES.medications,
        [LAB_INVESTIGATIONS]: DB_TABLES.labTests,
        [ADVICES]: DB_TABLES.advices,
        [EXAMINATION_FINDINGS]: DB_TABLES.examinations,
        [LAB_VITALS]: DB_TABLES.labVitals,
    };

    fetchItemsFromDb = async (): Promise<void> => {
        const { itemId, match } = this.props;
        const { pageSize, showDashboardFilters } = this;
        const { filter } = match.params;
        this.config = GenieConfiguration.configs.find((c) => c.id === itemId);

        this.setState({ isLoading: true, isStateChanged: false });
        let items: Item[] = [];

        if (this.config?.fetch) {
            items = await this.config.fetch();
        } else {
            const docId = getMySingleDoctorId() || '';
            items = await getG(docId, this.genieMap[itemId], Number.MIN_SAFE_INTEGER);
        }

        if (showDashboardFilters.includes(itemId)) {
            const filterData: FilterData = {} as FilterData;

            items.forEach((i) => {
                if (i.id.startsWith(LOCAL_ID_PREFIX) && !(i as GMedication).med_cat) {
                    (i as GUIItem).currentItemStatus = 'uncoded';
                } else if ((i as GMedication).med_cat) {
                    (i as GUIItem).currentItemStatus = 'nad';
                } else {
                    (i as GUIItem).currentItemStatus = 'coded';
                }
            });

            (Object.keys(filtersObj) as FilterType[]).forEach((k) => {
                const len = filtersObj[k].getLength(items);
                filterData[k] = {
                    count: len,
                };
            });
            this.counts = filterData;
        }

        this.setState({
            items: items,
            isLoading: false,
            filterState: filter,
        });

        if (this.props.itemId !== MEDICINES) return;
        const { getData } = filtersObj[filter];
        const filteredItems = getData(items || []);
        this.fetchSuggestions(filteredItems.slice(0, pageSize));
    };

    handleTableChange = (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<Item> | SorterResult<Item>[],
        extra: TableCurrentDataSource<Item>,
    ): void => {
        const { pageSize } = this;
        const { current } = pagination;
        const { currentDataSource } = extra;

        if (!current || !pageSize) return;

        const items = currentDataSource.slice((current - 1) * pageSize, current * pageSize);
        this.fetchSuggestions(items);
    };

    fetchSuggestions = (items: Item[]): void => {
        const medsToSend = (items as MedicationsEntity[])
            .map(
                ({
                    name,
                    id,
                    form,
                    dosage_form,
                    quantity,
                    dose,
                    generic_name,
                    generic_id,
                    manufacturer_name,
                    manufacturer_id,
                    frequency,
                    duration,
                    med_cat,
                }) => ({
                    name,
                    id,
                    form: dosage_form || form || dose?.unit,
                    quantity: quantity?.custom,
                    unit: dose?.unit,
                    uid: dose?.id,
                    generic_name: generic_name,
                    generic_id: generic_id,
                    manufacturer_name: manufacturer_name,
                    manufacturer_id: manufacturer_id,
                    frequency: frequency,
                    duration: duration,
                    med_cat,
                }),
            )
            .filter((i) => i.id.startsWith(LOCAL_ID_PREFIX) && !i.med_cat);

        if (medsToSend.length === 0) return;

        fetchDrugSearch({ medications: medsToSend }, FROM_GENIE_DASHBOARD)
            .then((res) => {
                const { items = [] } = this.state;
                const result = [];
                for (let i = 0; i < items.length; i++) {
                    const newItem = {
                        ...items[i],
                        suggestions: res[items[i].id],
                    };
                    result.push(newItem);
                }
                this.setState({
                    items: result,
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    handleTableChangeWithDebounce = debounce(this.handleTableChange, 300);

    onSaveEditedMedicine = async (element: GenieItem): Promise<void> => {
        if (element) {
            const { items } = this.state;
            this.setState({
                items: items?.map((i) =>
                    i.id === (element as Item).id &&
                    (i as GUIItem).currentItemStatus === (element as GUIItem).currentItemStatus
                        ? { ...i, ...element }
                        : i,
                ),
                isStateChanged: true,
            });
        }
    };

    setItems = (elements: GeniePadElementsSettingItem[]): void => {
        this.setState({
            items: elements,
            isStateChanged: true,
        });
    };

    async componentDidMount(): Promise<void> {
        const { sectionNameConfig } = this.props;

        this.fetchItemsFromDb();

        this.setState({
            sectionNameConfig: sectionNameConfig,
        });
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        const { itemId, sectionNameConfig } = this.props;
        if (prevProps.itemId !== itemId) {
            this.fetchItemsFromDb();
            this.setState({ editSectionId: undefined });
        }

        if (
            Object.keys(prevProps?.sectionNameConfig || {}).length !==
            Object.keys(sectionNameConfig || {}).length
        ) {
            this.setState({
                sectionNameConfig: sectionNameConfig,
            });
        }
    }

    componentWillUnmount(): void {
        const { dispatch, itemId } = this.props;
        const { isStateChanged } = this.state;
        isStateChanged && itemId === MEDICINES && dispatch(fetchSnackingQuestions());
    }

    setElement = (element: GenieItem): void => {
        this.setState({ element: element });
    };

    clearElement = (): void => {
        this.setState({ element: undefined });
    };

    setStatusFilter = (filterType: FilterType): void => {
        const { itemId, history } = this.props;
        const { filterState, tableKey, items } = this.state;
        const { pageSize } = this;
        if (filterState === filterType) {
            return;
        }
        this.setState({
            filterState: filterType,
            tableKey: tableKey + 1,
        });
        if (items) {
            const { getData } = filtersObj[filterType];
            const filteredItems = getData(items || []);
            this.fetchSuggestions(filteredItems.slice(0, pageSize));
        }
        setIsPageBlocked(false);
        history.push(GO_TO_MY_GENIE('genie-configuration', itemId, filterType));
    };

    trimAndLowerCase = (text?: string): string | undefined => text?.trim().toLowerCase();

    onSuggestedSelect = (
        id: string,
        medicine: CodedMedications,
        labelForTracking: string,
        index?: number,
    ): void => {
        const { items = [] } = this.state;
        const { trimAndLowerCase } = this;
        const currentMed = items.find((i) => i.id === id) as GMedication;
        const { actual_name } = medicine as MedicationsEntity;

        const apiToMed = apiDrugToMedicationEntity(medicine);

        if (currentMed && items) {
            const newItems = items.map((med) => {
                const {
                    name: name1,
                    generic_name: generic_name1,
                    form: form1,
                    dosage_form: dosage_form1,
                } = med as GMedication;

                const {
                    name: name2,
                    generic_name: generic_name2,
                    form: form2,
                    dosage_form: dosage_form2,
                } = currentMed;

                if (
                    trimAndLowerCase(name1) === trimAndLowerCase(name2) &&
                    trimAndLowerCase(generic_name1) === trimAndLowerCase(generic_name2) &&
                    trimAndLowerCase(form1) === trimAndLowerCase(form2) &&
                    trimAndLowerCase(dosage_form1) === trimAndLowerCase(dosage_form2)
                ) {
                    const newMed = {
                        ...apiToMed,
                        ...med,
                        id: medicine.id,
                        name: medicine.name,
                        form: '',
                        dosage_form: medicine.dosage?.dosage_form || '',
                        df_id: medicine.dosage?.df_id,
                        generic_id: medicine.generic_id,
                        generic_name: medicine.generic_name,
                        product_type: medicine.product_type,
                        soa: medicine.soa || false,
                        manufacturer_name: medicine.manufacturer_name,
                        hxng_mapped: medicine.hxng_mapped,
                        hxng_status: medicine.hxng_status,
                        replaced_from: med,
                        replaced_track: {
                            label: labelForTracking,
                            index,
                        },
                        actual_name: actual_name,
                        suggestions: undefined,
                        med_cat: undefined,
                    };

                    if ((med as GMedication).df_id === medicine.dosage.df_id) {
                        newMed.dose = (med as GMedication).dose;
                    } else {
                        newMed.dose = apiToMed.dose;
                    }

                    return newMed;
                }
                return med;
            });
            this.setState({
                items: newItems,
                isStateChanged: true,
            });

            const filterData: FilterData = {} as FilterData;
            (Object.keys(filtersObj) as FilterType[]).forEach((k) => {
                const len = filtersObj[k].getLength(newItems);
                filterData[k] = {
                    count: len,
                };
            });
            this.counts = filterData;

            track('GENIE_DASHBOARD_SUGGESTION_SELECT', {
                newMed: medicine.id,
                newMedName: medicine.name,
                currentMed: currentMed.id,
                currentMedName: (currentMed as GMedication).name,
                labelForTracking,
                keepName: actual_name ? 'true' : 'false',
                actual_name,
            });
        }
    };

    onNotADrugSelect = (id: string, med_cat: MedicineCategory): void => {
        const { items = [] } = this.state;
        const currentMed = items.find((i) => i.id === id);

        if (currentMed) {
            const newMed = {
                ...currentMed,
                med_cat,
                currentItemStatus: 'nad',
                suggestions: undefined,
            };
            const newItems = items.map((i) => (i.id === id ? newMed : i));
            this.setState({
                items: newItems,
                isStateChanged: true,
            });

            const filterData: FilterData = {} as FilterData;
            (Object.keys(filtersObj) as FilterType[]).forEach((k) => {
                const len = filtersObj[k].getLength(newItems);
                filterData[k] = {
                    count: len,
                };
            });
            this.counts = filterData;

            track('GENIE_DASHBOARD_MEDICINES', {
                propertyChanged: 'med_cat',
                id: currentMed.id,
                value: med_cat,
            });
        }
    };

    onMarkAsDrug = (id: string): void => {
        const { items = [] } = this.state;
        const currentMed = items.find((i) => i.id === id);

        if (currentMed) {
            const newMed = {
                ...currentMed,
                med_cat: undefined,
                currentItemStatus: 'uncoded',
            };
            const newItems = items.map((i) => (i.id === id ? newMed : i));
            this.setState({
                items: newItems,
                isStateChanged: true,
            });

            const filterData: FilterData = {} as FilterData;
            (Object.keys(filtersObj) as FilterType[]).forEach((k) => {
                const len = filtersObj[k].getLength(newItems);
                filterData[k] = {
                    count: len,
                };
            });
            this.counts = filterData;

            track('GENIE_DASHBOARD_MEDICINES', {
                propertyChanged: 'med_cat',
                id: currentMed.id,
                value: 'undefined',
            });
        }
    };

    onFormChange = (id: string, form?: string): void => {
        const { items = [] } = this.state;
        const currentMed = items.find((i) => i.id === id);

        if (currentMed) {
            const newMed = { ...currentMed, form: form, dosage_form: form };
            const newItems = items.map((i) => (i.id === id ? newMed : i));
            this.setState({
                items: newItems,
                isStateChanged: true,
            });

            track('GENIE_DASHBOARD_MEDICINES', {
                propertyChanged: 'form',
                id: currentMed.id,
                value: form,
            });
        }
    };

    onGenericNameChange = (id: string, generic?: { id: string; name: string }): void => {
        const { items = [] } = this.state;
        const currentMed = items.find((i) => i.id === id);

        if (currentMed) {
            const newMed = { ...currentMed, generic_name: generic?.name, generic_id: generic?.id };
            const newItems = items.map((i) => (i.id === id ? newMed : i));
            this.setState({
                items: newItems,
                isStateChanged: true,
            });

            track('GENIE_DASHBOARD_MEDICINES', {
                propertyChanged: 'generic name',
                id: currentMed.id,
                value: generic?.name,
            });
        }
    };

    onManufacturerNameChange = (id: string, manufacturer?: { id: string; name: string }): void => {
        const { items = [] } = this.state;
        const currentMed = items.find((i) => i.id === id);

        if (currentMed) {
            const newMed = {
                ...currentMed,
                manufacturer_name: manufacturer?.name,
                manufacturer_id: manufacturer?.id,
            };
            const newItems = items.map((i) => (i.id === id ? newMed : i));
            this.setState({
                items: newItems,
                isStateChanged: true,
            });

            track('GENIE_DASHBOARD_MEDICINES', {
                propertyChanged: 'manufacturer name',
                id: currentMed.id,
                value: manufacturer?.name,
            });
        }
    };

    onOTCChange = (id: string): void => {
        const { items = [] } = this.state;
        const currentMed = items.find((i) => i.id === id);

        if (currentMed) {
            const newMed = {
                ...currentMed,
                is_otc: !(currentMed as GMedication).is_otc,
            };
            const newItems = items.map((i) => (i.id === id ? newMed : i));
            this.setState({
                items: newItems,
                isStateChanged: true,
            });

            track('GENIE_DASHBOARD_MEDICINES', {
                propertyChanged: 'otc',
                id: currentMed.id,
                value: String(!(currentMed as GMedication).is_otc),
            });
        }
    };

    onRemarkChange = (id: string, value: string) => {
        const { items = [] } = this.state;
        const currentLabTest = items.find((i) => i.id === id);
        if (currentLabTest) {
            const newLabTest = {
                ...currentLabTest,
                remark: value,
            };
            const newItems = items.map((i) => (i.id === id ? newLabTest : i));
            this.setState({
                items: newItems,
                isStateChanged: true,
            });

            track('GENIE_DASHBOARD_LAB_INVESTIGATIONS', {
                propertyChanged: 'remark',
                id: currentLabTest.id,
                value: value,
            });
        }
    };

    onSave = async (itemsArray?: Item[], isAddMedicinesDialogVisible?: boolean): Promise<void> => {
        try {
            this.setState({ isSaveChangesLoading: true });
            const { itemId, dispatch } = this.props;
            const { items = [], sectionNameConfig } = this.state;
            const { showDashboardFilters } = this;
            const genieKey = GenieConfiguration.configs.find((i) => i.id === itemId)?.genieKey;
            if (genieKey) {
                try {
                    const docId = getMySingleDoctorId() || '';
                    const { version } = await getItemFromMisc<GenieVersion>(
                        docId,
                        MISC_KEYS.genieVersion,
                    );

                    if (!docId) {
                        console.error('pushGenieToBE=>', 'docId not found');
                        return;
                    }

                    let newItems = itemsArray || items;
                    if (showDashboardFilters.includes(itemId)) {
                        newItems = newItems.map((i) => ({
                            ...i,
                            suggestions: undefined,
                            currentItemStatus: undefined,
                        }));
                    }

                    if (genieKey === 'settings') {
                        const settings = await getItemFromMisc<GenieSettings>(
                            docId,
                            MISC_KEYS.settings,
                        );
                        await pushGenie(docId, {
                            id: docId,
                            version,
                            settings: {
                                ...settings,
                                padElements: items as GeniePadElementsSettingItem[],
                            },
                        });
                    } else {
                        await pushGenie(docId, { id: docId, version, [genieKey]: newItems });
                    }
                    dispatch(fetchMyGenie(undefined, undefined, this.fetchItemsFromDb));
                    notification.success({
                        message: 'Successfully saved!',
                        duration: 5,
                    });
                } catch (e) {
                    console.error('pushGenie => ', e);
                    alert('Unable to save changes, please try again');
                    captureError(e as Error);
                    track('ERROR', { on: 'saveGenie', what: (e as Error).message });
                }
            } else {
                captureErrorString('genieKey not found');
            }

            if (sectionNameConfig) {
                dispatch(upsertSectionNameConfig(sectionNameConfig, getMySingleDoctorId() || ''));
            }
            this.setState({
                isSaveChangesLoading: false,
                isStateChanged: false,
                isAddMedicinesDialogVisible,
            });
        } catch (err) {
            captureError(err as Error);
            notification.error({
                message: 'Error while saving',
                duration: 5,
            });
        }

        track('GENIE_CONFIGURE_SAVE');
    };

    handlePaginationChange = (): void => {
        if (this.tableRef.current) {
            this.tableRef.current.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    };

    expandedRowRender = (item: Item): JSX.Element | undefined => {
        const columns: TableColumnsType<Item> = [
            {
                title: 'Suggestions',
                dataIndex: 'suggestions',
                key: 'suggestions',
                className: '',
                render: (suggestions?: CodedMedications[]): ReactNode => {
                    const notMedicineStatus =
                        suggestions && suggestions.length && suggestions[0].non_medicine_status;
                    return {
                        children: (
                            <div className="flex items-center space-x-16 hover-parent-element">
                                <span className="text-darwin-neutral-900 italic whitespace-nowrap">
                                    Did you mean
                                </span>
                                <div className="flex space-x-16">
                                    {notMedicineStatus ? (
                                        <Fragment>
                                            <div
                                                className="font-400 text-13 text-darwin-primary-500 whitespace-nowrap cursor-pointer rounded-8 border-darwin-primary-500 border-1 py-6 px-16"
                                                onClick={() =>
                                                    this.onNotADrugSelect(
                                                        item.id,
                                                        notMedicineStatus,
                                                    )
                                                }
                                            >
                                                It's {notADrugObj[notMedicineStatus]}
                                            </div>

                                            <div
                                                className="font-400 text-13 text-darwin-primary-500 whitespace-nowrap cursor-pointer rounded-8 border-darwin-primary-500 border-1 py-6 px-16"
                                                onClick={() =>
                                                    this.onNotADrugSelect(item.id, 'nad')
                                                }
                                            >
                                                Not a Drug
                                            </div>

                                            <IssuesWithSuggestion
                                                currentMedicine={item as GUIItem}
                                            />
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            {suggestions?.map((med, index) => (
                                                <div
                                                    key={med.id}
                                                    onClick={() =>
                                                        this.onSuggestedSelect(
                                                            item.id,
                                                            med,
                                                            GD_SUGGESTED,
                                                            index,
                                                        )
                                                    }
                                                    className="cursor-pointer rounded-8 border-darwin-primary-500 border-1 py-6 px-16"
                                                >
                                                    <div className="flex space-x-12 items-center">
                                                        <span className="whitespace-nowrap font-400 text-13 text-darwin-primary-500">
                                                            {med.name}
                                                        </span>
                                                        {med.dosage?.dosage_form && (
                                                            <span className="whitespace-nowrap text-darwin-neutral-700 px-4 py-2 rounded-4 border border-darwin-neutral-200 text-10">
                                                                {med.dosage.dosage_form}
                                                            </span>
                                                        )}
                                                    </div>
                                                    {med.generic_name?.trim() && (
                                                        <span className="max-w-400 font-400 text-12 text-darwin-neutral-600 mt-2 truncate-overflow-2">
                                                            {med.generic_name}
                                                        </span>
                                                    )}
                                                    {med.manufacturer_name?.trim() && (
                                                        <span className="max-w-400 font-400 text-11 text-darwin-neutral-500 mt-2 truncate-overflow-2">
                                                            Mfr: {med.manufacturer_name}
                                                        </span>
                                                    )}
                                                </div>
                                            ))}

                                            <IssuesWithSuggestion
                                                currentMedicine={item as GUIItem}
                                            />
                                        </Fragment>
                                    )}
                                </div>
                            </div>
                        ),
                        props: {
                            style: { backgroundColor: '#fafafa' },
                        },
                    };
                },
            },
        ];

        const data = [item];
        if ((item as GUIItem).suggestions)
            return (
                <Table
                    columns={columns}
                    dataSource={data}
                    pagination={false}
                    showHeader={false}
                    className="overflow-y-hidden overflow-x-auto hide-scrollbar"
                    bordered
                />
            );
    };

    onReset = () => {
        const { isStateChanged } = this.state;
        const isReset =
            isStateChanged &&
            window.confirm(
                'Are you sure you want to reset your setup? Unsynced data will be lost.',
            );
        if (isReset) {
            this.fetchItemsFromDb();
            track('GENIE_DASHBOARD_RESET');
        }
    };

    addMedicinesDialogToggleHandler = () => {
        const { isAddMedicinesDialogVisible } = this.state;

        this.setState({
            isAddMedicinesDialogVisible: !isAddMedicinesDialogVisible,
        });

        track('GENIE_DASHBOARD_ADD_MEDICINES', {
            action: isAddMedicinesDialogVisible ? 'Dialog Close' : 'Dialog Open',
        });
    };

    onAddMedicine = async (
        med: MedicationsEntity,
        isAddMedicinesDialogVisible?: boolean,
    ): Promise<void> => {
        const { items = [] } = this.state;
        const { id, med_cat } = med;
        const isLocalDrug = id.startsWith(LOCAL_ID_PREFIX);

        for (let i = 0; i < items.length; i++) {
            if (items[i].id === id) {
                notification.error({
                    message: 'Medicine is already added!',
                    duration: 5,
                });
                return;
            }
        }
        const currentMedStatus = med_cat ? 'nad' : isLocalDrug ? 'uncoded' : 'coded';
        const newMed = {
            ...med,
            currentMedStatus,
        };
        const newItems = [...items, newMed];

        await this.onSave(newItems, isAddMedicinesDialogVisible);
    };

    onSaveClick = () => this.onSave();

    onSectionNameEditName = (sectionName: string, name: string) => {
        const { sectionNameConfig } = this.state;

        this.setState({
            sectionNameConfig: {
                ...sectionNameConfig,
                [sectionName]: name,
            },
        });
    };

    deleteAllHandler = () => {
        const { itemId } = this.props;
        const { items, filterState } = this.state;
        const { showDashboardFilters } = this;
        if (items) {
            const newItems = items.filter((i) => (i as GUIItem).currentItemStatus !== filterState);
            this.setState({ items: newItems, isStateChanged: true });

            if (showDashboardFilters.includes(itemId)) {
                const filterData: FilterData = {} as FilterData;
                (Object.keys(filtersObj) as FilterType[]).forEach((k) => {
                    const t = filtersObj[k].getData(newItems);
                    filterData[k] = {
                        count: t.length,
                    };
                });
                this.counts = filterData;
            }
        }
    };

    onSectionNameEdit = (sectionName?: string) => {
        const { rxClinicId } = this.props;
        // TODO: part of genie dashboard

        if (rxClinicId && getDefaultTemplateV2(rxClinicId, 'PRINT')) {
            this.setState({
                editSectionId: sectionName,
            });
        } else if (getTemplates()?.print) {
            const t = Modal.confirm({
                title: 'Click to configure your RX template for Section Name printing?',
                okText: 'Yes',
                cancelText: 'No',
                okButtonProps: { className: 'primary-btn font-lato' },
                cancelButtonProps: { className: 'neutral-btn font-lato' },
                visible: true,
                keyboard: true,
                closable: false,
                onOk: async () => {
                    his.push(GO_TO_MY_RX_TEMPLATE);
                },
                onCancel: (args) => {
                    t.destroy();
                    return;
                },
                bodyStyle: { padding: '24px' },
            });
        } else {
            this.setState({
                editSectionId: sectionName,
            });
        }
    };

    render(): ReactNode {
        const { itemId, name } = this.props;
        const {
            items,
            isLoading,
            element,
            filterState,
            isSaveChangesLoading,
            isStateChanged,
            tableKey,
            searchAndReplaceMedicine,
            isAddMedicinesDialogVisible,
            sectionNameConfig,
            editSectionId,
        } = this.state;
        const {
            counts,
            pageSize,
            expandedRowRender,
            onReset,
            addMedicinesDialogToggleHandler,
            onAddMedicine,
            onSaveClick,
            showDashboardFilters,
            config,
            deleteAllHandler,
        } = this;
        const { getData } = filtersObj[filterState];
        const filteredItems = getData(items || []);

        return (
            <Fragment>
                {isStateChanged && items && <BlockHistoryGenie itemId={itemId} items={items} />}
                <div className="w-full h-full flex flex-col overflow-hidden">
                    {showDashboardFilters.includes(itemId) && (
                        <div className="flex items-end justify-between">
                            <CodeStatusFilters
                                data={counts}
                                isLoading={isLoading || false}
                                setFilter={this.setStatusFilter}
                                codeStatusFilter={filterState}
                                itemId={itemId}
                                name={name}
                            />

                            {itemId === MEDICINES ? (
                                <>
                                    <button
                                        className="flex items-center space-x-8 mr-16 mb-20 px-16 py-8 text-white bg-darwin-primary-500 font-700 rounded-4"
                                        onClick={addMedicinesDialogToggleHandler}
                                    >
                                        <span>
                                            <svg
                                                className="w-18 h-16 fill-white"
                                                viewBox="0 0 19 15"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M16.5312 5.46875C14.5625 3.53125 11.4062 3.53125 9.4375 5.46875C7.5 7.4375 7.5 10.5938 9.4375 12.5625C11.4062 14.5 14.5625 14.5 16.5312 12.5625C18.4688 10.5938 18.4688 7.4375 16.5312 5.46875ZM10.0312 7.125L14.875 11.9688C11.7188 13.9688 8.03125 10.2812 10.0312 7.125ZM15.9375 10.9062L11.0938 6.0625C14.25 4.0625 17.9688 7.75 15.9375 10.9062ZM3.5 0C1.5625 0 0 1.59375 0 3.5V10.4688C0 12.4062 1.5625 13.9375 3.5 13.9375C5.40625 13.9375 7 12.375 7 10.4688V3.5C7 1.59375 5.40625 0 3.5 0ZM5.5 7H1.5V3.5C1.5 0.84375 5.5 0.84375 5.5 3.5V7Z" />
                                            </svg>
                                        </span>

                                        <span>Add medicines</span>
                                    </button>
                                    <GenieMemorySidebar itemId={itemId} />
                                </>
                            ) : filterState === 'uncoded' ? (
                                <Button
                                    danger
                                    className="flex items-center space-x-8 mr-16 mb-20 text-darwin-status-warning-500 border border-darwin-status-warning-500 font-700 rounded-4"
                                    onClick={deleteAllHandler}
                                >
                                    <span>{config?.icon('fill-darwin-status-warning-500')}</span>
                                    <span>Delete all uncoded ({counts?.[filterState]?.count})</span>
                                </Button>
                            ) : itemId === LAB_INVESTIGATIONS ? (
                                <GenieMemorySidebar itemId={itemId} />
                            ) : null}
                        </div>
                    )}

                    {isLoading ? (
                        <div className="flex flex-1 flex-auto w-full items-center justify-center">
                            <AppLoader />
                        </div>
                    ) : (
                        <Fragment>
                            {this.config?.configTable ? (
                                <div className="overflow-scroll pb-100 mt-12">
                                    <ElementsConfigureTable
                                        config={items as GeniePadElementsSettingItem[]}
                                        onUpdate={(elements) => {
                                            this.setItems(elements);
                                        }}
                                        alternateSectionNameConfig={sectionNameConfig}
                                        onSectionNameEditName={this.onSectionNameEditName}
                                        isSectionNameEdit={editSectionId}
                                        onSectionNameEdit={this.onSectionNameEdit}
                                        disableRowBasedOnKey="isShown"
                                        customColumnConfig={[
                                            {
                                                title: 'Auto Copy to pad',
                                                keyName: 'isAutoCopy',
                                            },
                                        ]}
                                    />
                                </div>
                            ) : this.props.itemId === MEDICINES ? (
                                <Table
                                    id="genie-med-table"
                                    sticky
                                    dataSource={filteredItems}
                                    columns={this.getColumns(itemId, filterState)}
                                    className="overflow-x-hidden overflow-y-scroll pb-64 h-full"
                                    expandable={{
                                        expandedRowRender,
                                        defaultExpandAllRows: true,
                                    }}
                                    expandIconColumnIndex={-1}
                                    scroll={{
                                        x: 900,
                                    }}
                                    pagination={{
                                        position: ['bottomCenter'],
                                        pageSize: pageSize,
                                        hideOnSinglePage: true,
                                        onChange: this.handlePaginationChange,
                                        showSizeChanger: false,
                                    }}
                                    rowClassName={'hover-parent-element relative'}
                                    key={tableKey}
                                    ref={this.tableRef}
                                    onChange={this.handleTableChangeWithDebounce}
                                    locale={{
                                        emptyText: <EmptyView name={name} />,
                                    }}
                                />
                            ) : (
                                <Table
                                    sticky
                                    dataSource={filteredItems}
                                    columns={this.getColumns(itemId, filterState)}
                                    pagination={false}
                                    className="overflow-scroll pb-100"
                                    key={tableKey}
                                    locale={{
                                        emptyText: <EmptyView name={name} />,
                                    }}
                                />
                            )}

                            <GenieMedTable
                                onSave={this.onSaveEditedMedicine}
                                clearElement={this.clearElement}
                                element={element}
                            />
                        </Fragment>
                    )}

                    <div className="absolute bottom-12 right-16 left-16 bg-white z-20">
                        <div className="flex items-center justify-between rounded-8 bg-actionPrimary bottom-24 inset-x-10 px-16 py-8 cta-row">
                            <Button type="ghost" className="text-white" onClick={onReset}>
                                Reset
                            </Button>
                            {editSectionId ? (
                                <AntTooltip content={'Please fill the required Section Name'}>
                                    <button
                                        className="px-16 py-8 btn--small primary-btn-v2 tooltip-wrapper opacity-50"
                                        disabled={true}
                                    >
                                        <p>Save Changes</p>
                                    </button>
                                </AntTooltip>
                            ) : (
                                <button
                                    onClick={onSaveClick}
                                    className="px-16 py-8 btn--small primary-btn-v2 tooltip-wrapper"
                                    disabled={isSaveChangesLoading || isLoading}
                                >
                                    {isSaveChangesLoading && (
                                        <div className="w-20 h-20">
                                            <svg className="circular-loader" viewBox="25 25 50 50">
                                                <circle
                                                    className="loader-path"
                                                    cx="50"
                                                    cy="50"
                                                    r="20"
                                                    fill="none"
                                                    stroke="#000000"
                                                    stroke-width="3"
                                                ></circle>
                                            </svg>
                                        </div>
                                    )}
                                    <p>Save Changes</p>
                                </button>
                            )}
                        </div>
                    </div>

                    {searchAndReplaceMedicine && (
                        <SearchAndReplaceMedicine
                            closeMe={() => this.setState({ searchAndReplaceMedicine: undefined })}
                            defaultValue={searchAndReplaceMedicine}
                            onSuggestedSelect={(medicine) => {
                                this.onSuggestedSelect(
                                    searchAndReplaceMedicine.id,
                                    medicine,
                                    GD_SEARCH_REPLACE,
                                );
                                this.setState({ searchAndReplaceMedicine: undefined });
                            }}
                        />
                    )}

                    {isAddMedicinesDialogVisible && (
                        <AddMedicines
                            closeMe={addMedicinesDialogToggleHandler}
                            onAddMedicine={onAddMedicine}
                        />
                    )}
                </div>
            </Fragment>
        );
    }
}

export default connect((state: GlobalState) => ({
    sectionNameConfig: getSectionNameConfig(state),
    rxClinicId: getRxClinicId(state),
}))(withRouter(ListGenieItems));
